export default "__VITE_ASSET__BJEXcS9Z__"